var template = jQuery("<div class=\"oskari-crosshair\">\n        <div class=\"oskari-crosshair-vertical-bar\"></div>\n        <div class=\"oskari-crosshair-horizontal-bar\"></div>\n    </div>");
var crosshairOnMap = false;
export var isCrosshairActive = function isCrosshairActive() {
  return crosshairOnMap;
};
/**
 * @method toggleCrosshair
 * toggles the crosshair marking the center of the map
 */
export var toggleCrosshair = function toggleCrosshair(mapEl) {
  if (isCrosshairActive()) {
    removeCrosshair(mapEl);
  } else {
    addCrosshair(mapEl);
  }
};
export var removeCrosshair = function removeCrosshair(mapEl) {
  if (crosshairOnMap) {
    jQuery(mapEl).find('div.oskari-crosshair').remove();
    crosshairOnMap = false;
  }
};
export var addCrosshair = function addCrosshair(mapEl) {
  if (!crosshairOnMap) {
    jQuery(mapEl).append(template.clone());
    crosshairOnMap = true;
  }
};